window.TrackWebPixelEvent = function (event, data) {
  window.Shopify.analytics.publish(event, data);
};

function trackEventWebToCall() {
  const dataGTM = {
    event: 'web_to_call',
    method: '',
    link_url: '',
    store_name: 'BULY SRC'
  };

  document
    .querySelectorAll('[data-contact-form-method]')
    ?.forEach(link => {
      link.addEventListener('click', e => {
        const targetLink = e.currentTarget;
        dataGTM.link_url = targetLink.href;
        if (targetLink.href.includes('wa.me')) {
          dataGTM.method = 'Whatsapp';
        } else if (targetLink.href.includes('page.line.me')) {
          dataGTM.method = 'Line';
        } else if (targetLink.href.includes('tel')) {
          dataGTM.method = 'phone';
          dataGTM.link_url = targetLink.href.replace('tel:', '');
        } else if (targetLink.href.includes('mailto')) {
          dataGTM.method = 'email';
        }
        window.TrackWebPixelEvent(dataGTM.event, dataGTM);
      });
    });
};

trackEventWebToCall();

//get Variant data
async function getProductData(url) {
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching variant data', error);
  }
}

